import React from "react";
import Sidebar from "../reusable/Sidebar.jsx";
import parse from "html-react-parser";
import axios from "axios";
const GLOBAL = require('../../commonConstants.js');
const url = GLOBAL.BASE_URL + "MasterClassMappings";


function MasterClasses() {
  const [getMasterClasses, setMasterClasses] = React.useState(null);
  
  // Static data based on the Word document content
  const staticMasterClasses = [
    {
      id: 1,
      title: "ISUW 2024 | MASTER CLASS ON ENERGY TRANSITION STRATEGIES AND PATHWAYS TO NET ZERO POWER SYSTEMS",
      description: `
        <p>The utility industry value chain was undergoing a major transformation and transition. Driven by regulatory, policy, business, technology, and the consumer, change was being wrought in all aspects of the value chain. This energy transition drove standards, codes, new technologies, and new investments. It also led to the emergence of disruptive technologies.</p>
        <p><strong>Discussion Points:</strong></p>
        <ol type="a">
          <li>Energy Transition to Net Zero -- An Overview</li>
          <li>Key Stakeholders and their roles</li>
          <li>Current State -- A Global Perspective</li>
          <li>The Future State -- Vision, Mission & Architecture</li>
          <li>Technologies - The Key Enabler (DER, EV, DR/ DSM, Blockchain, AMI etc.)</li>
          <li>Case Studies and Examples</li>
          <li>Conclusion and Q/A</li>
        </ol>
        <p><strong>Tutors:</strong></p>
        <ul>
          <li>Mani Vadari, Founder and President, Modern Grid Solutions (Virtual)</li>
          <li>Anant Venkateswaran, Industry Professional, ISGF and Hitachi Energy</li>
          <li>Rahul Tongia, Senior Fellow- CSEP, Founding Advisor-ISGF</li>
          <li>Reji Kumar Pillai, President, ISGF</li>
        </ul>
      `,
      date: "12 March 2024",
      location: "Hotel The Lalit, New Delhi",
      photos: "https://flic.kr/s/aHBqjBimtp",
      videos: [
        "https://youtu.be/MJFHzR64iPw?si=Ri1akAaysKJu3LLB",
        "https://youtu.be/ySKhGqZYGMI?si=BmRsLZysfOdU2o6E"
      ],
      agenda: "S.no 1 File Attached"
    },
    {
      id: 2,
      title: "ISUW 2023 | ENERGY TRANSITION TO NET ZERO POWER SYSTEM -- STRATEGIES AND PATHWAYS",
      description: `
        <p>The aim of this tutorial was to define an outline for the energy transition pathways of power systems to Net Zero so that countries could achieve their Net Zero targets. This Master Class, certified by IEEE Education, covered the global and Indian perspectives on choices for energy transition pathways and strategies.</p>
        <p><strong>Discussion Points:</strong></p>
        <ol type="a">
          <li>Energy Transition to Net Zero -- An Overview</li>
          <li>Key Stakeholders and Their Roles</li>
          <li>Current State -- Global and Indian Perspectives</li>
          <li>The Future State -- Vision and Pathways</li>
          <li>DER's - Dispatching Grid Scale DER's</li>
          <li>Technologies - The Key Enablers</li>
          <li>The Consumer/ Prosumer</li>
          <li>Integrating Security and Privacy into the Evolving Net Zero Energy Ecosystem Across the Value Chain</li>
          <li>Case Studies and Examples</li>
        </ol>
        <p><strong>Tutors:</strong></p>
        <ul>
          <li>Anant Venkateswaran, Industry professional, ISGF and Hitachi Energy</li>
          <li>Mani Vadari, Founder and President, Modern Grid Solutions</li>
          <li>Reji Kumar Pillai, President, ISGF</li>
          <li>Rahul Tongia, Senior Fellow, CSEP</li>
          <li>Stefan Tenbohlen, Head of Institute of Energy Transmission and High Voltage Engineering, University of Stuttgart</li>
          <li>Andrew Ginter, VP-Industrial Security, Waterfall Security Solutions</li>
        </ul>
      `,
      date: "28 FEBRUARY 2023",
      location: "Hotel The Lalit, New Delhi",
      photos: "https://flic.kr/s/aHBqjAvhYH",
      videos: [
        "https://youtu.be/ff7IzZzvNY4?si=HAPtT4ATpOEZsns4",
        "https://youtu.be/LMSBuGsDqA4?si=L8GHlRICkLClMgwO"
      ],
      agenda: "S.no 2 File Attached"
    },
    {
      id: 3,
      title: "ISUW 2020 | TRACK-1: TECHNOLOGIES ENABLING ENERGY TRANSITION: DIGITALIZATION",
      description: `
        <p>Energy transition was a pathway towards the transformation of the global energy sector from fossil-based to zero-carbon, and digitalization facilitated this transformation story through the use of information and communication technology.</p>
        <p><strong>Session 1:</strong></p>
        <ol>
          <li>Digital Consumers</li>
          <li>AMI and Utility Transformation -- Different Use Cases</li>
          <li>Asset Management through Advance Analytics</li>
        </ol>
        <p><strong>Tutors:</strong> Anant Venkateswaran (ISGF), Ajoy Rajani (ISGF)</p>
        <p><strong>Session 2:</strong></p>
        <ol>
          <li>Cybersecurity in the Digital Age</li>
          <li>Cloud -- The Enabler for Digitalization</li>
          <li>An Introduction to AI, Machine Learning, and Big Data and their Impacts on the utility</li>
          <li>Unlocking the "Fifth Fuel" - Increased Energy Efficiency with Machine Learning and Big Data</li>
        </ol>
        <p><strong>Tutors:</strong> Andrew Ginter (VP, Industrial Security at Waterfall Security Solutions, Canada), Anant Venkateswaran (ISGF)</p>
      `,
      date: "03 MARCH 2020",
      location: "Hotel The Lalit, New Delhi",
      photos: "https://flic.kr/s/aHsmM7aCM1",
      videos: null,
      agenda: "S.no 3 File Attached"
    },
    {
      id: 4,
      title: "ISUW 2020 | TRACK-2: TECHNOLOGIES ENABLING ENERGY TRANSITION: E-MOBILITY",
      description: `
        <p>This course covered EV policies and programs in India vis-a-vis those of leading countries in the world, and included an introduction to EV charging infrastructure, standards, and communication technologies.</p>
        <p><strong>Session 1:</strong></p>
        <ol>
          <li>Global EV Deployment</li>
          <li>EV Technologies</li>
          <li>International Best Practices</li>
        </ol>
        <p><strong>Tutors:</strong> Girish Ghatikar (Senior Program Manager- EPRI, California, USA, and Chair of ISGF Working Group)</p>
        <p><strong>Session 2:</strong></p>
        <ol>
          <li>Electric Vehicle Charging Infrastructure</li>
          <li>Vehicle to Grid Integration</li>
          <li>Enhancement and Health Management</li>
        </ol>
        <p><strong>Tutors:</strong> Lonneke Driessen-Mutters (Executive Director, Open Charge Alliance), Reji Kumar Pillai (President, India Smart Grid Forum)</p>
      `,
      date: "03 MARCH 2020",
      location: "Hotel The Lalit, New Delhi",
      photos: "https://flic.kr/s/aHsmMa1YHD",
      videos: null,
      agenda: "S.no 4 File Attached"
    },
    {
      id: 5,
      title: "ISUW 2020 | TRACK-3: ADVANCED CYBER SECURITY",
      description: `
        <p>Security became a crucial factor for the success and wide deployment of smart grid networks. A cyber-attack on the power grid could have resulted in complete disruption of all activities in society.</p>
        <p><strong>Session 1:</strong></p>
        <ol>
          <li>Attack Patterns</li>
          <li>Defenses and Their Limitations</li>
        </ol>
        <p><strong>Tutors:</strong> Andrew Ginter (VP, Industrial Security at Waterfall Security Solutions, Canada)</p>
        <p><strong>Session 2:</strong> Designs for High-Threat Environments</p>
        <p><strong>Tutors:</strong> Andrew Ginter (VP, Industrial Security at Waterfall Security Solutions, Canada)</p>
      `,
      date: "03 MARCH 2020",
      location: "Hotel The Lalit, New Delhi",
      photos: "https://flic.kr/s/aHsmM9TrAq",
      videos: null,
      agenda: "S.no 5 File Attached"
    },
    {
      id: 6,
      title: "ISUW 2020 | TRACK-4: TECHNOLOGIES ENABLING ENERGY TRANSITION: ENERGY STORAGE SYSTEMS (ESS)",
      description: `
        <p>This session discussed key topics related to battery energy storage systems requirements for integration of renewable energy into the grid.</p>
        <p><strong>Session 1:</strong></p>
        <ol>
          <li>Battery Technologies for Grid Storage and Electric Vehicles</li>
          <li>Energy Storage Systems Roadmap for India: 2019-2032</li>
        </ol>
        <p><strong>Tutors:</strong> Arumugam Manthiram (Director, Texas Materials Institute, The University of Texas, Austin, USA - On Video), Ravi Seethapathy (Chair of ISGF Working Group and Chairman, Biosirus Inc., Canada)</p>
        <p><strong>Session 2:</strong></p>
        <ol>
          <li>Manufacturing of Energy Storage Systems in India</li>
          <li>Value Streams and Business Case for Energy Storage: Impact of Power Market Design and Regulation</li>
          <li>Battery Requirements for Electric Mobility in India</li>
          <li>Storage Projects: International Best Practices and Lessons for India</li>
        </ol>
        <p><strong>Tutors:</strong> Rahul Walawalkar (President - India Energy Storage Alliance - IESA)</p>
      `,
      date: "03 MARCH 2020",
      location: "Hotel The Lalit, New Delhi",
      photos: "https://flic.kr/s/aHsmMi2G6y",
      videos: null,
      agenda: "S.no 6 File Attached"
    },
    {
      id: 7,
      title: "ISUW 2019 | Theme 1: Energy Transition and Utility Transformation",
      description: `
        <p>A 360-degree in-depth review of business transformation triggered by the introduction of Smart Metering or AMI.</p>
        <p><strong>Topics:</strong></p>
        <ol>
          <li>AMI related Utility Transformation Real-world Experiences</li>
          <li>Cloud Strategies and Roadmap for Digital Utilities</li>
          <li>Advanced Grid Applications (Resiliency and Future Readiness, Digitalization and Asset Health)</li>
        </ol>
        <p><strong>Tutors:</strong> Anant Venkateswaran (Director, ISGF Master Classes, USA), Jonathan Pettit (Manager - AMS Program, Oncor Electric Delivery, USA), Randall Schmidt (Oncor Electric Delivery, USA), Nitin Kumar (Principal Cloud Architect, CloudKrest, USA), Rama Rao Bandireddy (Oracle Utilities, India), Suhas Dhapre (ISGF and formerly with Tata Power Company Ltd., Mumbai, India), Ajoy Rajani (Sr. Executive VP, AEML, India)</p>
      `,
      date: "12 March 2019",
      location: "Manekshaw Center, Delhi",
      photos: "https://flic.kr/s/aHsmCkNvPu",
      videos: null,
      agenda: "S.no 7 File Attached"
    },
    {
      id: 8,
      title: "ISUW 2019 | Theme-2: Next Generation Technologies for Utility Transformation",
      description: `
        <p>Focus on IoT, AI, and Blockchain Technologies for utility transformation.</p>
        <p><strong>Topics:</strong></p>
        <ol>
          <li>Energy Blockchain Consortium Certified Champion Training Session (EBCCC)</li>
          <li>Next Generation Technologies for Utility Transformation (Artificial Intelligence, Analytics and Visualization, Asset Health Analytics)</li>
          <li>BOTs for Utilities</li>
          <li>Blockchain Applications for Energy Sector</li>
        </ol>
        <p><strong>Tutors:</strong> Chris Peoples (Energy Blockchain Consortium, USA), Marcus Bonner (GE, USA), Kartik Poddar (Haptik India), Lorien Gamaroff (CEO, Centbee, South Africa), Shrirang K. Karandikar (Energy Web Foundation, Germany), Reena Suri (General Manager, India Smart Grid Forum)</p>
      `,
      date: "12 March 2019",
      location: "Manekshaw Center, Delhi",
      photos: "https://flic.kr/s/aHsmC3mWRP",
      videos: null,
      agenda: "S.no 8 File Attached"
    }
  ];

  React.useEffect(() => {
    // Try to fetch from API first, if fails use static data
    axios.get(url)
      .then((response) => {
        setMasterClasses(response.data);
      })
      .catch((error) => {
        console.log("Using static data for Master Classes");
        setMasterClasses(staticMasterClasses);
      });
  }, []);

  if (!getMasterClasses) return null;

  return (
    <>
      <section
        className="isgf-breadcum isgf_master_classes_breadcum"
        style={{
          backgroundImage: `url(${
            process.env.PUBLIC_URL +
            "/images/bilateral-workshops/bilateral-workshops-banner.jpg"
          })`,
        }}
      >
        <div className="container">
          <div className="isgf-breadcum-box">
            <h1>Master Classes</h1>
            <p>
              Home {">"} ISGF Initiatives {">"} Master Classes
            </p>
          </div>
        </div>
      </section>
      <section className="master-classes">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 ">
              <div className="row">
                <div className="col-md-12">
                  <div className="heading mb-3">
                    <h2>ISGF Master Classes</h2>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="benefits_membership master-classes-events">
                    <div className="mb-3">
                      <div className="isgf_accordion">
                        <div className="accordion" id="accordionExample">
                          {getMasterClasses &&
                            getMasterClasses.map((data, index) => (
                              <div className="accordion-item" key={data.id || index}>
                                <h2 className="accordion-header bg-green" id={`heading${index}`}>
                                  <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapseOne${index}`}
                                    aria-expanded="false"
                                    aria-controls={`collapseOne${index}`}
                                  >
                                    {data.title}
                                  </button>
                                </h2>
                                <div 
                                  id={`collapseOne${index}`} 
                                  className="accordion-collapse collapse p-3" 
                                  aria-expanded="false" 
                                  aria-labelledby={`heading${index}`} 
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="master-class-content">
                                    {parse(`${data.description}`)}
                                    
                                    <div className="row g-4 mt-4">
                                      {data.agenda && (
                                        <div className="col-md-3 col-lg">
                                          <div className="agenda-box text-center">
                                            <h4>Agenda</h4>
                                            <img
                                              src="images/woman-energy/agenda-icon-1.png"
                                              className="img-fluid"
                                              style={{ height: "45px" }}
                                              alt="Agenda"
                                            />
                                            <div className="btn btn-orange mt-3 p-2 d-block">
                                              {data.agenda}
                                            </div>
                                          </div>
                                        </div>
                                      )}

                                      {data.date && (
                                        <div className="col-md-3 col-lg">
                                          <div className="agenda-box text-center">
                                            <h4>Date</h4>
                                            <img
                                              src="images/woman-energy/agenda-icon-2.png"
                                              className="img-fluid"
                                              style={{ height: "45px" }}
                                              alt="Date"
                                            />
                                            <div className="btn btn-orange mb-0 mt-3 p-2 d-block">
                                              {data.date}
                                            </div>
                                          </div>
                                        </div>
                                      )}

                                      {data.location && (
                                        <div className="col-md-3 col-lg">
                                          <div className="agenda-box text-center">
                                            <h4>Location</h4>
                                            <img
                                              src="images/woman-energy/location.jpg"
                                              className="img-fluid"
                                              style={{ height: "45px" }}
                                              alt="Location"
                                            />
                                            <div className="btn btn-orange mb-0 mt-3 p-2 d-block">
                                              {data.location}
                                            </div>
                                          </div>
                                        </div>
                                      )}

                                      {data.photos && (
                                        <div className="col-md-3 col-lg">
                                          <div className="agenda-box text-center">
                                            <h4>View Photos</h4>
                                            <img
                                              src="images/woman-energy/agenda-icon-4.png"
                                              className="img-fluid"
                                              style={{ height: "45px" }}
                                              alt="Photos"
                                            />
                                            <a
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              href={data.photos}
                                              className="btn btn-orange mt-3 p-2 d-block"
                                            >
                                              View Photos
                                            </a>
                                          </div>
                                        </div>
                                      )}

                                      {data.videos && Array.isArray(data.videos) && data.videos.length > 0 && (
                                        <div className="col-md-3 col-lg">
                                          <div className="agenda-box text-center">
                                            <h4>Videos</h4>
                                            <img
                                              src="images/woman-energy/agenda-icon-3.png"
                                              className="img-fluid"
                                              style={{ height: "45px" }}
                                              alt="Videos"
                                            />
                                            {data.videos.map((video, videoIndex) => (
                                              <a
                                                key={videoIndex}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                href={video}
                                                className="btn btn-orange mt-3 p-2 d-block mb-2"
                                              >
                                                Part {videoIndex + 1}
                                              </a>
                                            ))}
                                          </div>
                                        </div>
                                      )}

                                      {data.videos && !Array.isArray(data.videos) && data.videos !== "Not Available" && (
                                        <div className="col-md-3 col-lg">
                                          <div className="agenda-box text-center">
                                            <h4>Videos</h4>
                                            <img
                                              src="images/woman-energy/agenda-icon-3.png"
                                              className="img-fluid"
                                              style={{ height: "45px" }}
                                              alt="Videos"
                                            />
                                            <a
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              href={data.videos}
                                              className="btn btn-orange mt-3 p-2 d-block"
                                            >
                                              View Recording
                                            </a>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <Sidebar />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default MasterClasses;